import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Obvious Disguises',
		description:
			'Train spies to wear increasingly obvious disguises. The fake mustaches are getting bigger.'
	},
	{
		name: 'Loud Sneaking',
		description:
			'Develop a new sneaking technique that involves maximum noise and visibility.'
	},
	{
		name: 'Neon Camouflage',
		description:
			"Equip spies with bright neon camouflage. They're so visible, they're invisible!"
	},
	{
		name: 'Quantum Infiltration',
		description:
			'Spies now exist in multiple states of being caught and not caught.'
	},
	{
		name: 'Time-Traveling Agents',
		description:
			'Send spies to infiltrate the past, but they keep spoiling their own missions.'
	},
	{
		name: 'Multiverse Espionage',
		description:
			'Infiltrate parallel universes where everyone is already a spy.'
	},
	{
		name: 'Void Infiltration',
		description:
			'Send agents into the void. They report back with existential intelligence.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Espionage Academy'],
	departments[DepartmentIds['Espionage Academy']].basePrice * 3,
	UpgradeIds.EpaExponent1
)

export default array
